<template>
	<svg
		class="svg-icon anticon"
		aria-hidden="true"
		:style="{
			color: color,
			width: size,
			height: size,
			cursor: 'pointer',
		}"
		@click="$emit('click')"
	>
		<use :xlink:href="iconName"></use>
	</svg>
</template>

<script>
// 后续icon库的更新需要覆盖assets全部文件
import "./svg";
export default {
	name: "DiyIcon",
	props: {
		iconClass: {
			type: String,
			required: true,
		},
		color: {
			// 字体颜色
			type: String,
			default: "",
		},
		size: {
			type: String,
			default: "14px",
		},
	},
	data() {
		return {};
	},
	computed: {
		iconName() {
			return `#jywIcon-${this.iconClass}`;
		},
	},
	mounted() {
		// console.log(this.$attrs, this.$listeners, 222);
	},
};
</script>

<style lang="less" scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	// vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>
